import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const zabbix = defineConnector({
  identifier: "zabbix",
  name: "Zabbix",
  tagLine: "Infrastructure monitoring",
  logo,
  protocol: "http",
  tags: ["observability", "it"],
  defaultUrlPattern: ({ baseUrl }) => domainToRegex(baseUrl),
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Get your Zabbix API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to your Zabbix instance and navigate to **Users › API Tokens** to generate an API token.",
        },
      ],
    },
    {
      title: "Enter your Zabbix details",
      items: [
        {
          kind: "baseUrl",
          label: "Zabbix URL",
          required: true,
          placeholder: "https://zabbix.example.com",
          target: { kind: "configuration", field: "baseUrl" },
          helperText: "The base URL of your Zabbix instance.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url: `${baseUrl}/api_jsonrpc.php`,
      method: "POST",
      headers: { "Content-Type": "application/json-rpc" },
      body: JSON.stringify({
        jsonrpc: "2.0",
        method: "user.get",
        params: { output: ["userid"], limit: 1 },
        id: 1,
      }),
      expectedBodyContains: '"result"',
    }),
  },
  publicEnvVars: ({ baseUrl }) => ({
    ZABBIX_URL: baseUrl || "",
  }),
});
